<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    :icon="$attrs.onlyIcon"
    :outlined="opciones[tipo].outlined && !$attrs.onlyIcon"
    :color="opciones[tipo].color"
    :small="opciones[tipo].small"
    :large="opciones[tipo].large"
    class="rounded-lg elevation-0">
    <v-icon
      v-if="$attrs.iconText">
      {{ $attrs.iconText }}
    </v-icon>
    <span class="mx-4" v-if="$attrs.label">{{ $attrs.label }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'CustomButton',
  inheritAttrs: false,
  props: {
    tipo: String,
  },
  data() {
    return {
      opciones: {
        formAceptar: {
          color: 'secondary',
          outlined: false,
          small: true,
        },
        formCancelar: {
          color: 'secondary',
          outlined: true,
          small: true,
        },
        agregar: {
          color: 'secondary',
          outlined: true,
          large: true,
        },
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss">
</style>
